import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, boxImage, systemChecks } from '../data/salesCopy';
export function SystemIntro() {
  return <section className="bg-brand-brown px-4 py-9 sm:py-12" data-id="element-183" data-mp="238dhuszioqy0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-184" data-mp="23b7z6bn8hvn7">
        <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-brand-gold" data-id="element-185" data-mp="286x30r6adypb">
          Le système visuel complet 6-en-1
        </p>
        <h2 className="mt-1.5 font-serif text-3xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-186" data-mp="1bk26gg9uf07y">
          🧘 Yin Yoga Pro™
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-[12.5px] font-semibold uppercase leading-snug tracking-wide text-brand-sand sm:text-sm" data-id="element-187" data-mp="1khci42qkorde">
          Des ressources visuelles prêtes à utiliser pour les professeurs de Yin
          Yoga
        </p>
        <p className="mt-1.5 text-[12px] font-medium text-white/70 sm:text-[13px]" data-id="element-188" data-mp="2vznburiw81vd">
          Postures • Séquences • Création • Adaptations • Thématiques •
          Planification
        </p>

        <a href={OFFER_ANCHOR} className="mt-4 block" data-id="element-189" data-mp="15gjej0wn0ua2">
          <img src={boxImage} alt="Les 6 modules du système YIN YOGA PRO™" className="mx-auto w-full max-w-[280px] sm:max-w-[340px]" data-id="element-190" data-mp="11gsdm4decxrt" />
        </a>

        <ul className="mx-auto mt-4 grid max-w-2xl grid-cols-1 gap-1.5 text-left sm:grid-cols-2" data-id="element-191" data-mp="rjnsm7vaf8cl">
          {systemChecks.map(item => <li key={item} className="flex items-start gap-1.5 rounded bg-white/10 px-2.5 py-1.5 text-[12.5px] font-semibold leading-snug text-white" data-id="element-192" data-mp="ml2s07c4imnm">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-193" data-mp="drzk0ek8z20d" />
              {item}
            </li>)}
        </ul>

        <div className="mt-5 flex justify-center" data-id="element-194" data-mp="3siga2ok2y71">
          <CTAButton size="lg" data-id="element-195" data-mp="3uzbbmpwo433n">🧘 Oui ! Je veux le système complet</CTAButton>
        </div>
      </div>
    </section>;
}